import { Spinner } from "@components/ui/spinner";

const index = () => {
  return (
    <div className="flex h-[70vh]  relative flex-col items-center select-none">
      <h1 className="text-[250px] absolute top-12 font-bold leading-[250px] text-black/10 ">
        404
      </h1>
      <img
        src="/notfound.png"
        alt=""
        className="absolute top-20  select-none"
      />
      <div className="absolute text-center top-[65%] flex flex-col items-center">
        {" "}
        <h4 className="text-[32px] font-medium text-[#222] leading-[32px]">
          Opps Page Not Found
        </h4>
        <span className="text-[#5D585B] font-light text-[20px]">
          But don't worry - let's get you back on track!{" "}
        </span>
      </div>
    </div>
  );
};

export default index;

export const PageLoader = () => {
  return (
    <div className="h-[79vh] flex items-center justify-center">
      <Spinner />
    </div>
  );
};
